import React from "react"

export const LinkOqt = React.memo((props) => {
  const { text, options, formik, name } = props;
  return (
    <div style={{ padding: 8, width: "100%" }}>    
      <a {...options} href={formik.values[name]} target="_blank">{text || "Vínculo externo"}</a>
    </div>
  )
})

